/*
* Resideo/LifeWhere
* Copyright (C) 2018-2023 Resideo/LifeWhere
* mailto:nathan.williams@resideo.com
*/

import http from "../http-common";

const controller = "/login";
const loginService = {
    getExtendedToken: async (tokenExchange) => {
        const response = await http.post(`${controller}/tokenexchange`, tokenExchange);
        return response.data;
    }
};
export default loginService;